function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigationList } from "@sprout/list-navigation";
import { useMemo } from "react";
import Divider from "sprout-ui-dom/dist/Divider";
import { Flex, Text, Box } from "sprout-ui-primitives";
import styled from "styled-components";
import ArchivePageTopic from "./ArchivePageTopic";
const SUPPORTED_ACTIONS = [
    "OPEN"
];
const ArchivePageTopicsDivider = styled(Divider)`
  flex: 1;
`;
const ArchivePageTopics = (props)=>{
    const { title , topics  } = props;
    const { navProps , Provider  } = useNavigationList(title, useMemo(()=>({
            actions: SUPPORTED_ACTIONS
        }), []));
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsxs(Box, _objectSpread({}, navProps, {
            mb: 7,
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    height: "48px",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "15px",
                            fontWeight: "bold",
                            caps: true,
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(ArchivePageTopicsDivider, {
                            height: "1px",
                            bg: "blue.500",
                            ml: 1
                        })
                    ]
                }),
                topics.map((topic)=>{
                    return /*#__PURE__*/ _jsx(ArchivePageTopic, {
                        topic: topic
                    }, topic.nodeId);
                })
            ]
        }))
    });
};
export default ArchivePageTopics;
